<template>
  <div
    class="dwp-group dwp-select-none dwp-border-gray-300 dwp-border dwp-rounded-md hover:dwp-border-primary dwp-transition-colors dwp-duration-200"
  >
    <div class="dwp-p-4 sm:dwp-p-6 dwp-space-y-4 dwp-flex dwp-flex-col dwp-items-start">
      <slot />
      <div style="margin-top: auto;">
        <button
          @click="$emit('selected')"
          v-if="button"
          type="button"
          data-cy="box-select"
          class="dwp-mt-6 dwp-inline-flex dwp-items-center dwp-border-gray-400 dwp-text-gray-700 group-hover:dwp-border-primary group-hover:dwp-text-primary-600 dwp-border-transparent dwp-leading-4 dwp-font-medium dwp-rounded focus:dwp-outline-none dwp-transition dwp-ease-in-out dwp-duration-150 dwp-px-4 dwp-py-2 dwp-text-sm dwp-bg-transparent hover:dwp-bg-transparent dwp-border hover:dwp-opacity-75 dwp-border-gray-500"
        >{{ this.buttonText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    button: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
      default: "Choose",
    },
  },
};
</script>